//EXTERNAL
import React from "react"
import { useLocation } from "react-router-dom"
//COMPONENTS
import Article from "../components/Article"
import Header from "../components/Header"
import Post from "../components/Post"
import Story from "../components/Story"
import BackToGalleryButton from "../components/BackToGalleryButton"
//ASSETS
import PicnicLogo from "../assets/picnic-logo-white.png"
//FUNCTIONS

export default function Gallery({ isDesktop }) {
  const path = "https://ads.picnic-media.com/"
  const location = useLocation()
  const pathname = location.pathname.split("/")
  const format = pathname[2]
  const creativeId = pathname[3]

  function buildFormat() {
    if (format === "post") return <Post path={buildPath()} id={creativeId} />
    if (format === "story") return <Story path={buildPath()} id={creativeId} />
  }

  function buildPath() {
    return path + creativeId
  }

  return (
    <div className="bg-pink">
      {isDesktop ? (
        <>
          <Header Logo={PicnicLogo} />
          <BackToGalleryButton />
        </>
      ) : null}
      <Article isDesktop={isDesktop} format={buildFormat()} />
    </div>
  )
}
